import { MKT_STATUS_TYPE } from 'helpers/marketplaceStatus';

const getFailedOfferStatus = () => ({ unifiedStatusType: MKT_STATUS_TYPE.failed });

export default getFailedOfferStatus;
